import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import { useLocalization } from '@shared-ui/localization-context';
import { EGDSIcon, EGDSIconSize } from '../../icons/icon/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSTextInput } from '../text-input/index.esm.js';
import styles from '../../styles/uitk-egds-input.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { EGDSContextWrapper } from '../../utils/context-provider/index.esm.js';
import { analyticsTracker } from '../../utils/analytics-tracker/index.esm.js';
const getClassNameList = classNames.bind(styles);
class FakeInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false
    };
    this.getPlaceholderText = this.getPlaceholderText.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.setState({
      mounted: true
    });
  }
  handleChange(e) {
    const {
      onChange
    } = this.props;
    if (onChange) {
      onChange(e);
    }
  }
  handleClear() {
    const {
      handleClear
    } = this.props;
    if (typeof handleClear === 'function') {
      handleClear();
    }
  }
  getPlaceholderText() {
    const {
      props
    } = this;
    let result = '';
    if (props.placeholder) {
      result = props.placeholder;
    } else if (props.value) {
      // Uitk-field needs some placeholder as default to place label properly
      result = 'Placeholder';
    }
    return result;
  }
  render() {
    const {
      mounted
    } = this.state;
    const {
      className,
      domRef,
      analytics,
      hasClearButton,
      icon,
      trailingIcon,
      id,
      invalid,
      label,
      l10n,
      placeholder,
      required,
      value,
      trailingText,
      clearButtonLabel,
      ...attrs
    } = this.props;
    const showClearButton = mounted && hasClearButton && value;
    const buttonClassNames = getClassNameList(className, 'uitk-fake-input', 'uitk-form-field-trigger');
    const inputClassNames = getClassNameList({
      'is-hidden': mounted
    });
    const iconTitle = [l10n.formatText('clear'), clearButtonLabel || label].join(' ');
    if (attrs.handleClear) {
      delete attrs.handleClear;
    }
    const ariaLabelParts = [];
    // Whether or not this input is required
    if (required) ariaLabelParts[0] = l10n.formatText('fake.input.required');
    // Provided aria-label or just the already visible label
    ariaLabelParts[1] = attrs['aria-label'] ?? label;
    // Visible parts of label (value/placeholder followed by optional trailing text)
    ariaLabelParts[2] = `${value || placeholder || ''}${trailingText && value ? ` ${trailingText}` : ''}`;
    return jsx(EGDSTextInput, {
      className: inputClassNames,
      id: id,
      invalid: invalid,
      label: label,
      required: required,
      onChange: this.handleChange,
      placeholder: this.getPlaceholderText(),
      value: value || '',
      icon: icon,
      children: mounted && jsx(EGDSContextWrapper, {
        children: (context, data) => jsxs(Fragment, {
          children: [jsxs("button", {
            ...attrs,
            "aria-label": ariaLabelParts.filter(str => str.length > 0).join(', '),
            className: getClassNameList(buttonClassNames, context === 'uitk-field-context' && 'uitk-field-fake-input', data.icon && 'uitk-field-fake-input-hasicon', data.invalid && 'uitk-field-fake-input-invalid'),
            onClickCapture: analytics && analyticsTracker.bind(this, analytics),
            ref: domRef,
            type: "button",
            children: [value || placeholder, trailingText && value && ` ${trailingText}`, trailingIcon && jsx(EGDSIcon, {
              name: trailingIcon,
              className: getClassNameList(`uitk-fake-input-right-icon`),
              size: EGDSIconSize.SMALL
            })]
          }), showClearButton && jsx("button", {
            className: getClassNameList('uitk-clear-button', 'uitk-input-cta'),
            onClick: this.handleClear,
            type: "button",
            children: jsx(EGDSIcon, {
              id: "fake-input-clear-button",
              name: "cancel",
              size: EGDSIconSize.SMALL,
              title: iconTitle
            })
          })]
        })
      })
    });
  }
}
const EGDSFakeInput = props => {
  const l10n = useLocalization();
  return jsx(FakeInput, {
    l10n: l10n,
    ...props
  });
};
export { EGDSFakeInput };